import { useEffect, lazy, FC } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useGetApiV3Whoami } from 'mir-utils/api/whoami';
import { Loading } from 'mir-utils/components';
import { InstructionInstall } from 'pages/instruction_install';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { notUndefined } from 'mir-utils/utils/utilities';

LicenseInfo.setLicenseKey(notUndefined(process.env.REACT_APP_LICENSE_KEY));

const LoginPage = lazy(() => import('./login-page'));
const MainRouter = lazy(() => import('./router/MainRouter'));

export const App: FC = () => {
  const [whoami] = useGetApiV3Whoami();
  const location = useLocation();

  /**
   * Этот кусок кода нужен для тех случаев, когда пользователь перешёл по ссылке
   * в ЛК в конкретное место, но был не залогинен. После логина он попадает в место,
   * которое было указано в ссылке.
   *
   * Используется sessionStorage, а не переменная, потому что если логиниться через
   * соц. сети, то переменная после редиректа из сайта соц. сети стирается и пользователя
   * перенаправляет на дефолтную страницу.
   *
   * Из-за того, что хук срабатывает при каждом обновлении whoami, появляется следующая
   * фича: если пользователь после выхода из ЛК сразу же зайдёт обратно, то его перенаправит
   * в то место, где он был перед выходом. Фича работает только в рамках одной сессии(то есть
   * если закрыть текущую вкладку с ЛК, то фича не сработает). Эта фича известна и вопросов
   * не вызвала.
   */
  useEffect(() => {
    if (
      whoami?.userId === null &&
      !(location.pathname + location.search).startsWith('/login') &&
      !(location.pathname + location.search).startsWith('/instruction-install') &&
      location.pathname + location.search !== '/'
    ) {
      sessionStorage.setItem('authRedirect', location.pathname + location.search);
    }
  }, [whoami]);

  if (whoami === undefined) {
    return (
      <Box height="100vh" width="100%">
        <Loading />
      </Box>
    );
  }

  /* КОСТЫЛЬ!
   * Нужен для редиректа пользователя в нужное место со старой ссылки,
   * которая встречается в старых письмах.
   * history.replace(react-router) и history.replaceState(DOM) не
   * подходят, потому что не заменяют текущий url, а добавляют
   * новое содержимое к нему(из-за того, что в строке есть параметры).
   */
  if (
    window.location.href.includes('?next=/#/utm/download') ||
    window.location.href.includes('?next=/utm/download')
  ) {
    window.location.href = window.location.origin + '/ngfw/download';
  } else if (window.location.href.includes('register')) {
    window.location.href = window.location.origin + '/login';
  }

  const { userId } = whoami;

  return (
    <Switch>
      <Route path="/instruction-install" render={() => <InstructionInstall />} />
      <Route path="/login" render={() => (userId === null ? <LoginPage /> : <Redirect to="/" />)} />
      <Route
        path="/"
        render={() => (userId === null ? <Redirect to="/login" /> : <MainRouter />)}
      />
    </Switch>
  );
};
